export async function getConfig() {
    const url = `${process.env.REACT_APP_API_URL}Configuration`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getFailedLoginPageConfig() {
    const url = `${process.env.REACT_APP_API_URL}FailedLoginPageConfiguration`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getAccountDisabledPageConfig() {
    const url = `${process.env.REACT_APP_API_URL}AccountDisabledPageConfiguration`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getConfigProducts() {
    const url = `${process.env.REACT_APP_API_URL}Configuration/Products`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    });

    if (response.status === 200) {
        const data = await response.json();
        return Array.isArray(data) ? data : data.products;
    } else {
        throw response.statusText;
    }
}

export async function getConfigMessageTypes() {
    const url = `${process.env.REACT_APP_API_URL}Configuration/MessageTypes`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
			'Content-Type': 'application/json',
		},
    });

    if (response.status === 200 || response.status === 204) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getConfigRoleTypes() {
    const url = `${process.env.REACT_APP_API_URL}Configuration/Roles`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
			'Content-Type': 'application/json',
		},
    });

    if (response.status === 200 || response.status === 204) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

export async function getProductMessageTypes(produtIds) {
    const url = `${process.env.REACT_APP_API_URL}Configuration/Product/MessageTypes?productIds=${produtIds.join('&productIds=')}`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
			'Content-Type': 'application/json',
		},
    });

    if (response.status === 200 || response.status === 204) {
        return await response.json();
    } else {
        throw response.statusText;
    }   
}
